import InitializeLayout from '@js/layout';

import PlannerManager from '@js/managers/plannerManager';

InitializeLayout();

PlannerManager.initialize();
